
import { Component, Vue, Watch, Mixins } from 'vue-property-decorator'
import TimeSlot from '@/common/TimeSlot.js'
import countrycode from '@/common/countrycode'
import InputSear from '@/views/components/InputSear.vue'
import { TransTopReq } from '@/api/admin/risk'
@Component({
    components: {
        InputSear
    }
})
export default class OperationLog extends Vue {
    countrycode = countrycode
    logRouteList = []
    time_date = TimeSlot.today.value()
    shortcutDate = {
        disabledDate(date) {
            return date && date.valueOf() > Date.now()
        },
        shortcuts: [TimeSlot.yestoday, TimeSlot.today, TimeSlot.recentWeek, TimeSlot.recentMonth, TimeSlot.recentThreeMonth]
    }
    searchData = {
        platform: 0,
        app_id: 0,
        pageSizes: [15, 30, 45, 60],
        page: 1, // 默认第一页
        limit: 15, // 默认每页20条
        pageTotal: 0,
        stime: '',
        etime: '',
        opt_platform: null,
        opt_ip: '',
        opted_id: null,
        opt_account: '',
        device_id: '',
        opt_id: null,
        opt_type: '',
        user_id: null,
        phone_code: '',
        phone: '', //手机号
        tableData: [],
        columns: [
            // 表头文字
            { title: '日志ID', align: 'center', key: 'id', minWidth: 150 },
            { title: '操作类型接口', key: 'act_name', align: 'center', minWidth: 120 },
            { title: '玩家ID', key: 'user_id', align: 'center', minWidth: 80 },
            { title: '玩家绑定手机号', key: 'phone_no', align: 'center', minWidth: 100 },
            { title: '设备码', key: 'device_id', align: 'center', minWidth: 150 },
            { title: '操作时间', key: 'create_time', align: 'center', minWidth: 100 },
            { title: '操作人ip', key: 'ip_address', align: 'center', minWidth: 120 },
            {
                title: '操作结果',
                key: 'act_result',
                align: 'center',
                minWidth: 100,
                render: (h, params) => {
                    return h(
                        'span',
                        {
                            style: {
                                color: params.row.act_result == '失败' ? 'red' : '#000'
                            }
                        },
                        params.row.act_result
                    )
                }
            },
            { title: '操作描述', key: 'act_desc', align: 'center', minWidth: 300 }
        ]
    }

    getAdminLog(num?) {
        if (!this.time_date[0]) {
            return this.$Message.error('请选择时间')
        }
        if (num) {
            this.searchData.page = 1
        }
        let param = {
            mod: 'root',
            platid: this.searchData.platform,
            app_id: this.searchData.app_id,
            param: {
                _mod: 'manager',
                _func: 'GetUserActLog',
                _param: {
                    page: this.searchData.page,
                    limit: this.searchData.limit,
                    stime: Math.round(this.time_date[0].getTime() / 1000),
                    etime: Math.round(this.time_date[1].getTime() / 1000 + 24 * 60 * 60 - 1),
                    app_id: Number(this.searchData.app_id),
                    ip_address: this.searchData.opt_ip,
                    coder_no: this.searchData.phone_code == undefined ? '' : this.searchData.phone_code,
                    phone_no: String(this.searchData.phone),
                    user_id: Number(this.searchData.opt_id),
                    device_id: this.searchData.device_id,
                    act_type: Number(this.searchData.opt_type)
                }
            }
        }

        TransTopReq(param).then((res) => {
            this.searchData.tableData = res._param.list || []
            this.searchData.pageTotal = res._param.total * 1
        })
    }
    //分页
    pageChange(num) {
        this.searchData.page = num
        this.getAdminLog()
    }
    Percentchange(num) {
        this.searchData.limit = num
        this.searchData.page = 1
        this.getAdminLog()
    }
    getLogRoutes() {
        if (!this.searchData.app_id) return
        let param = {
            mod: 'root',
            platid: this.searchData.platform,
            app_id: this.searchData.app_id,
            param: {
                _mod: 'manager',
                _func: 'GetUserActType',
                _param: {
                    app_id: Number(this.searchData.app_id)
                }
            }
        }
        TransTopReq(param).then((res) => {
            this.logRouteList = []
            let data = res._param.data || {}
            for (let i in data) {
                ;(this.logRouteList as any).push({ route_key: i, rout_value: data[i] })
            }
        })
    }

    created() {
        // this.getLogRoutes()
        // this.getAdminLog()
    }
}
